import Box from '@mui/material/Box';
import { sp } from '@/theme/mui';
import { BaseField, FieldProps } from '@/components/atoms/BaseField/BaseField';

type Size = 'sm' | 'md';
interface TextAreaProps extends FieldProps<string> {
  className?: string;
  autoFocus?: boolean;
  placeholder?: string;
  size?: Size;
}

export const TextArea = ({
  className,
  placeholder,
  label,
  description,
  tooltip,
  isRequired,
  isHideTitle,
  size = 'md',
  value,
  isDisabled = false,
  onChange,
}: TextAreaProps) => {
  return (
    <BaseField
      label={label}
      description={description}
      tooltip={tooltip}
      isRequired={isRequired}
      isHideTitle={isHideTitle}
    >
      <Box
        component='textarea'
        className={className}
        placeholder={placeholder}
        value={value}
        onChange={(val: React.ChangeEvent<HTMLTextAreaElement>) =>
          onChange?.(val.target.value)
        }
        disabled={isDisabled}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          width: '100%',
          verticalAlign: 'top',
          minHeight: '50px',
          p: sp[12],
          typography: 'bodyMediumWeight',
          ...(size === 'sm' && {
            minHeight: '10px',
            p: sp[8],
            typography: 'bodySm',
            fontWeight: 500,
          }),
          color: '#404042',
          background: '#ffffff',
          border: '1px solid #b2b2b2',
          borderRadius: '8px',
          resize: 'vertical',
          '&:focus-within': {
            outline: '3px solid #f4a689',
            border: '1px solid #d67c61',
          },
          '&::placeholder': { color: '#d9d9d9' },
        }}
      />
    </BaseField>
  );
};

TextArea.displayName = 'TextArea';

export default TextArea;
